import apiClient from "./apiClient";

export const loginUser = async (username, password) => {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    const response = await apiClient.post("/login", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
};
